import React, { Suspense, lazy } from 'react'
import { AppBar, Container, Toolbar, Grid, Typography } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Logo from './Logo'
import butlerIcon from './butlerIcon.png'
const LocationWidget = lazy(() => import('../Widget/LocationWidget'))
const CorporateWidget = lazy(() => import('../Widget/CorporateWidget'))
const BulkWidget = lazy(() => import('../Widget/BulkWidget'))
const OffersWidget = lazy(() => import('../Widget/OffersWidget'))
const CartWidget = lazy(() => import('../Widget/CartWidget'))
const AvatarWidget = lazy(() => import('../Widget/AvatarWidget'))

const useStyles = makeStyles((theme) => ({
    iconsBarLeft: {
        display: "flex",
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    iconsBarRight: {
        display: "flex",
        justifyContent: 'flex-end',
        alignItems: 'center',
        '& > *': {
            marginLeft: theme.spacing(3),
        },
        [theme.breakpoints.between('xs', 'sm')]: {
            '& > *': {
                marginLeft: 0,
            },

        },
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'space-between',
            '& > *': {
                marginLeft: 0,
            },
        },
    },

}));

const NavigationBar = () => {
    const theme = useTheme();
    const classes = useStyles()
    const xs = useMediaQuery(theme.breakpoints.down('xs'));

    const xsSm = useMediaQuery(theme.breakpoints.between('xs', 'sm'));

    const typoProps = {
        variant: 'body1',
        component: 'span',
        color: 'primary'
    }
    const gridProps = {
        spacing: 2,
        justify: 'flex-end'
    }

    if (xsSm) {
        typoProps.variant = "subtitle2"
        gridProps.spacing = 1
        gridProps.justify = 'center'
    }

    if (xs) {
        return (
            <React.Fragment>

                <AppBar position="sticky">
                    <Toolbar>
                        <Grid container >
                            <Grid item xs={12} className={classes.iconsBarLeft}>
                                <Logo />
                                <Suspense fallback={<div>Address Loading...</div>}>
                                    <LocationWidget />
                                </Suspense>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>

                <AppBar position="fixed" style={{ top: 'auto', bottom: 0 }} >
                    <Toolbar>
                        <Grid container >
                            <Grid item xs={12} className={classes.iconsBarRight}>

                                <Suspense fallback={<div>Loading...</div>}>
                                    <CorporateWidget />
                                </Suspense>

                                <Suspense fallback={<div>Loading...</div>}>
                                    <BulkWidget />
                                </Suspense>

                                <Suspense fallback={<div>Loading...</div>}>
                                    <OffersWidget />
                                </Suspense>

                                <Suspense fallback={<div>Loading...</div>}>
                                    <CartWidget />
                                </Suspense>

                                <Suspense fallback={<div>Loading...</div>}>
                                    <AvatarWidget />
                                </Suspense>

                            </Grid>
                        </Grid>

                    </Toolbar>
                </AppBar>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <AppBar position="sticky">
                <Toolbar>
                    <Container>
                        <Grid container spacing={gridProps.spacing} >
                            <Grid item sm={5} className={classes.iconsBarLeft}>
                                <Logo />
                                <Suspense fallback={<div>Address Loading...</div>}>
                                    <LocationWidget />
                                </Suspense>
                            </Grid>

                            <Grid item sm={7} className={classes.iconsBarRight}>

                                <Suspense fallback={<div>Loading...</div>}>
                                    <CorporateWidget />
                                </Suspense>

                                <Suspense fallback={<div>Loading...</div>}>
                                    <BulkWidget />
                                </Suspense>

                                <Suspense fallback={<div>Loading...</div>}>
                                    <OffersWidget />
                                </Suspense>

                                <Suspense fallback={<div>Loading...</div>}>
                                    <CartWidget />
                                </Suspense>

                                <Suspense fallback={<div>Loading...</div>}>
                                    <AvatarWidget />
                                </Suspense>

                            </Grid>
                        </Grid>
                    </Container>
                </Toolbar>
            </AppBar>
            <AppBar position="sticky" color="secondary" style={{ top: '64px', left: 0 }} >
                <Toolbar style={{ minHeight: '32px' }}>
                    <Container>
                        <Grid container {...gridProps} >
                            <Grid item >
                                <Typography {...typoProps}>
                                    <strong>Call To Order: 978-079-7807 (Toll-Free)</strong>
                                </Typography>
                            </Grid>

                            <Grid item >
                                <Typography {...typoProps}>
                                    <strong> | </strong>
                                </Typography>
                            </Grid>

                            <Grid item >
                                <Typography {...typoProps}>
                                    <img alt="butler icon" src={butlerIcon} height="20px" />
                                </Typography>
                            </Grid>

                            <Grid item >
                                <Typography {...typoProps}>
                                    <strong>Now Serving at :
                                    </strong>
                                </Typography>
                            </Grid>

                            <Grid item>
                                <Typography {...typoProps}>
                                    <strong>Chandigarh</strong>
                                </Typography>
                            </Grid>
                            <Grid item >
                                <Typography {...typoProps}>
                                    <strong> | </strong>
                                </Typography>
                            </Grid>

                            <Grid item>
                                <Typography {...typoProps}>
                                    <strong>Mohali </strong>
                                </Typography>
                            </Grid>

                            <Grid item >
                                <Typography {...typoProps}>
                                    <strong> | </strong>
                                </Typography>
                            </Grid>

                            <Grid item>
                                <Typography {...typoProps}>
                                    <strong>Panchkula </strong>
                                </Typography>
                            </Grid>

                            <Grid item >
                                <Typography {...typoProps}>
                                    <strong> | </strong>
                                </Typography>
                            </Grid>

                            <Grid item>
                                <Typography {...typoProps}>
                                    <strong>Zirakpur </strong>
                                </Typography>
                            </Grid>

                            <Grid item >
                                <Typography {...typoProps}>
                                    <strong> | </strong>
                                </Typography>
                            </Grid>

                            <Grid item>
                                <Typography {...typoProps}>
                                    <strong>Kharar</strong>
                                </Typography>
                            </Grid>
                        </Grid>

                    </Container>
                </Toolbar>
            </AppBar>
        </React.Fragment>
    )
}


export default NavigationBar
